// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"24a4bdd4","95":"1524ee67","453":"179422e7","622":"a336cb8d","769":"a798a21e","901":"daa5e5d7"}[chunkId] + ".chunk.js";
};